<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img :src="Utils.getImgUrl('logo-small.png')" alt="StateMC Logo">
        <div>
          <strong><span class="color-primary">State</span>MC</strong>
          <p>{{ $t('footer.description') }}</p>
        </div>
      </div>

      <nav class="footer-links" aria-label="Footer Navigation">
        <v-btn
            v-for="(link, i) in links"
            :key="i"
            color="primary"
            variant="text"
            class="footer-link"
            :to="link.url"
        >
          {{ $t(link.text) }}
        </v-btn>
      </nav>

      <div class="socials">
        <a
            v-for="(social, index) in socials"
            :key="index"
            :href="social.url"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="social.text"
        >
          <v-img :src="social.image" :alt="social.text" :height="24" :width="24" />
        </a>
      </div>
    </div>

    <div class="footer-bottom">
      <span>{{ $t('mojangwarn.title') }}</span>
      <span>Copyright © {{ new Date().getFullYear() }} StateMC</span>
    </div>
  </footer>
</template>

<script setup>
import { Utils } from '@/modules/utils';

const socials = [
  {
    text: 'Discord',
    url: 'https://discord.com/invite/JNVkRxP',
    image: Utils.getImgUrl('social/discord.svg'),
  },
  {
    text: 'YouTube',
    url: 'https://www.youtube.com/channel/UCz6W7EFoaAJJ55CCWJRzsIg',
    image: Utils.getImgUrl('social/youtube.svg'),
  },
  {
    text: 'Teamspeak',
    url: 'ts3server://ts.statemc.de',
    image: Utils.getImgUrl('social/teamspeak.svg'),
  },
  {
    text: 'TikTok',
    url: 'https://www.tiktok.com/@statemc_de',
    image: Utils.getImgUrl('social/tiktok.svg'),
  },
  {
    text: 'Instagram',
    url: 'https://www.instagram.com/statemc.de/',
    image: Utils.getImgUrl('social/instagram.svg'),
  },
];

const links = [
  {
    text: 'imprint.title',
    url: '/imprint',
  },
  {
    text: 'policy.title',
    url: '/policy',
  },
];
</script>

<style scoped>
.site-footer {
  margin-top: 72px;
  border-top: 1px solid rgba(124, 232, 234, 0.14);
  background: rgb(var(--v-theme-site-chrome));
}

.footer-inner {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto auto;
  gap: 32px;
  align-items: center;
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
  padding: 34px 0;
}

.footer-brand {
  display: flex;
  gap: 16px;
  align-items: center;
}

.footer-brand img {
  width: 46px;
  height: 46px;
}

.footer-brand strong {
  display: block;
  color: white;
  font-size: 24px;
  line-height: 1;
}

.footer-brand p {
  max-width: 430px;
  margin: 8px 0 0;
  color: rgba(255, 255, 255, 0.58);
  line-height: 1.5;
}

.footer-links,
.socials {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-link {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0;
}

.socials a {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.04);
  transition: border-color 0.2s ease, background 0.2s ease;
}

.socials a:hover {
  border-color: rgba(124, 232, 234, 0.5);
  background: rgba(28, 176, 179, 0.12);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
  padding: 18px 0 26px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.48);
  font-size: 13px;
}

@media screen and (max-width: 980px) {
  .footer-inner {
    grid-template-columns: 1fr;
    align-items: flex-start;
  }

  .footer-links,
  .socials {
    flex-wrap: wrap;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 8px;
  }
}
</style>
